import React from 'react'

import { createRegisterableComponent } from '@news-mono/web-common'
import { FeatureHeadline } from './FeatureHeadline'
import { Classification } from '@news-mono/web-common'

export interface FeatureHeadlingProps {
    text: string
    classification: Classification | undefined
}

export const FeatureHeadlineRegistration = createRegisterableComponent(
    'feature-headline',
    (props: FeatureHeadlingProps) => {
        return (
            <FeatureHeadline
                text={props.text}
                classification={props.classification}
            />
        )
    },
)
